
      import View from './view.vue'
      import type { App, Plugin } from 'vue'

      export const ViewPlugin: Plugin = {
        install(app: App) {
          app.component('View', View)
        },
      }
      export { View }
      